var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditPanLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33331 13.3332C7.33331 12.965 7.63179 12.6665 7.99998 12.6665H14C14.3682 12.6665 14.6666 12.965 14.6666 13.3332C14.6666 13.7014 14.3682 13.9998 14 13.9998H7.99998C7.63179 13.9998 7.33331 13.7014 7.33331 13.3332Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.58577C11.8017 2.58577 11.6116 2.66453 11.4714 2.80473L3.26864 11.0075L2.91624 12.4171L4.32583 12.0647L12.5286 3.86192C12.598 3.7925 12.6531 3.71009 12.6906 3.6194C12.7282 3.5287 12.7475 3.43149 12.7475 3.33332C12.7475 3.23515 12.7282 3.13794 12.6906 3.04725C12.6531 2.95655 12.598 2.87414 12.5286 2.80473C12.4592 2.73531 12.3768 2.68025 12.2861 2.64268C12.1954 2.60511 12.0982 2.58577 12 2.58577ZM10.5286 1.86192C10.9188 1.47168 11.4481 1.25244 12 1.25244C12.2733 1.25244 12.5438 1.30626 12.7963 1.41084C13.0488 1.51541 13.2782 1.66869 13.4714 1.86192C13.6646 2.05514 13.8179 2.28454 13.9225 2.537C14.0271 2.78947 14.0809 3.06006 14.0809 3.33332C14.0809 3.60659 14.0271 3.87718 13.9225 4.12964C13.8179 4.3821 13.6646 4.6115 13.4714 4.80473L5.13806 13.1381C5.05263 13.2235 4.94557 13.2841 4.82835 13.3134L2.16168 13.9801C1.9345 14.0369 1.69418 13.9703 1.52859 13.8047C1.363 13.6391 1.29644 13.3988 1.35323 13.1716L2.0199 10.505C2.0492 10.3877 2.10982 10.2807 2.19526 10.1953L10.5286 1.86192Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditPanLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-pan-line.a5f832f8.svg";
export { ForwardRef as ReactComponent };